fx.ns("desktop.poster", class PosterBoard extends desktop.common.board.Board {
    constructor(model, componentFactory, options) {
        super(model, componentFactory, options);
    }

    /**************************** Getters / Setters **********************/

    get posterCreation() {
        return this.data;
    }

    set posterCreation(val) {
        this.data = val;
    }

    get currentView() {
        if (!this._currentView)
            this._currentView = new desktop.poster.PosterView(this);

        return this._currentView;
    }

    /*************************** Overrides  *************************/

    onReady()
    {
        super.onReady();

        this.on("photo-extracted", this._onPhotoExtracted, fx.service("MediasUploader"));
        this.on("photo-extracted", this._onPhotoExtracted, fx.service("GoogleService"));
    }

    buildBoard() {
        if (!this.posterCreation || !this.posterCreation.posterPage) return;

        let posterPage = this.posterCreation.posterPage;

        this.currentArea = new shared.stage.FrameArea(posterPage, this.model, this);
        this.currentArea.effect = "fade";

        this.addEditableArea(this.currentArea, { width: this.posterCreation.pageWidth, height: this.posterCreation.pageHeight })
        //this.addChild(this.currentArea, {width : this.posterCreation.pageWidth, height : this.posterCreation.pageHeight} );

        this.currentView.update(false);

        if (!this.model.hasFilteredPhoto && fx.get("mode") == "creating" && this.model.photos.length > 0) {
            let photos = [];
            for (var i = 0; i < this.model.photos.length; i++)
                photos.push(this.model.photos.getItemAt(i));

            let layouts = [];
            if (photos.length == 1 || this.hasHeic(photos)) {
                layouts = [this.model.layouts.getDefaultLayout()]
            }
            else {
                layouts = fx.service("LayoutsGenerator").getLayouts(photos);
            }

            this.currentArea.data.addPhoto(photos, this.currentArea.creation.pageWidth, this.currentArea.creation.pageHeight, layouts[0], true);
        }
    }

    hasHeic(photos) {
        for (const photo of photos) {
            const name = photo.file.name || '';
            if (name.toLowerCase().endsWith('.heic')) {
                return true;
            }
        }
        return false;
    }

    getArea() {
        return this.currentArea;
    }

    onDataEvent(event) {
        super.onDataEvent(event);

        if (event.type == "add-component") {
            // TODO : if photo is clicked on gallery, first try to find if there is some empty picture and fill it
            // if not photo is empty, get new layout with number of picture, apply it and add new photo
            if (event.detail.component_type == "photo" && event.detail.creation != "dropped") {
                //let photosComponents = this.currentArea.data.photosComponents;
                if (this.currentElement) {
                    this.currentElement.data.content = event.detail.content;
                }
                else {
                    if (this.currentArea) {
                        this.frame.show();
                        this.frame.currentArea = this.currentArea;
                        this.frame.currentElement = this.currentArea.addPhoto(event.detail);
                        this.delay(this.removeFrame, 250);
                    }
                }
            }
            else // if not photo or photo dropped
            {
                this._photoIndex = undefined;
                if (event.detail.page)
                    delete event.detail.page;

                // so ToolBar and Frame are removed
                this.currentElement = null;

                this.currentArea.addComponent(event.detail);
            }
        }

        if (event.type == "apply-layout") {
            let layout = this.model.layouts.find({ id: event.detail.content });

            if (this.currentArea)
                this.currentArea.applyLayout(layout /*, this.currentArea.activePart*/);

            event.cancel(); // so layout is not applied somewhere else
        }

    }


    /*************************** Events  *************************/

    onClick(event) {
    }


    _editCurrentElement() {
        if (this.currentElement instanceof shared.stage.components.Text)
            this.currentElement.onEdit();
    }

    onSelect(event)
    {
        super.onSelect(event);

        if (this.currentElement && this.currentElement.data && this.currentElement.data.isPhoto && this.currentElement.empty)
        {
            // let show photo galery
            //fx.set("photo-selected", this.currentElement);

            this.data.event("selectphotos", this.currentElement.data);
        }
    }

    _onPhotoExtracted(event)
    {
        /*let photoComponent = fx.get("photo-selected");

        if (photoComponent)
        {
            if (photoComponent.data)
                photoComponent.data.content = event.detail.id;

            //fx.set("photo-selected", null);
        }*/
    }

});